import React from "react";
import { FaCalendarAlt, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { formatValue } from "../../../utils/common";
import { useTranslation } from "react-i18next";

const SessionHeader = ({ session, usedDart, isExpanded, onToggle }) => {
  const { t } = useTranslation();

  const formatDate = () => {
    return session.createdAt
      ? session.createdAt.toDate().toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      : "???";
  };

  const getDartCode = () => {
    return usedDart ? usedDart.shortCode : "---";
  };

  const getAverage = () => {
    return formatValue(session.statistics["avg_median"]) ?? "No Score";
  };

  const getScore = () => {
    return formatValue(session.statistics["general_score"]) ?? "No Score";
  };

  return (
    <div className="w-full cursor-pointer select-none" onClick={onToggle}>
      {/* Mobile Layout (< sm) */}
      <div className="block sm:hidden">
        {/* First Row: Date and Dart */}
        <div className="flex justify-between items-center mb-2 gap-6">
          <div className="flex items-center text-white">
            <FaCalendarAlt className="text-test/70 mr-2 h-3 w-3" />
            <span className="text-xs">{formatDate()}</span>
          </div>
          <div className="text-highlight text-xs font-medium">
            {getDartCode()}
          </div>
        </div>

        {/* Second Row: Stats */}
        <div className="flex justify-between items-center gap-6">
          <div className="text-test text-xs">
            <span className="text-lightGray">501 Avg: </span>
            <span className="font-medium">{getAverage()}</span>
          </div>
          <div className="text-test text-xs">
            <span className="text-lightGray">
              {t("history.gameHistory.score")}:{" "}
            </span>
            <span className="font-medium">{getScore()}</span>
          </div>
        </div>
      </div>

      {/* Desktop Layout (>= sm) */}
      <div className="hidden sm:block">
        <div className="grid grid-cols-4 items-center w-full px-2 gap-2">
          {/* Date */}
          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center text-white">
              <FaCalendarAlt className="text-test/70 mr-2 h-4 w-4" />
              <span className="text-sm">{formatDate()}</span>
            </div>
          </div>

          {/* Dart */}
          <div className="flex flex-col items-center justify-center">
            <div className="text-highlight text-sm font-medium">
              {getDartCode()}
            </div>
          </div>

          {/* 501 Average */}
          <div className="flex flex-col items-center justify-center">
            <div className="text-test text-sm">
              <span className="text-lightGray">501 Avg: </span>
              <span className="font-medium">{getAverage()}</span>
            </div>
          </div>

          {/* Score */}
          <div className="flex flex-col items-center justify-center">
            <div className="text-test text-sm">
              <span className="text-lightGray">
                {t("history.gameHistory.score")}:{" "}
              </span>
              <span className="font-medium">{getScore()}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Dropdown Arrow */}
      <div className="flex justify-center mt-3">
        <div className="text-test transition-transform duration-200">
          {isExpanded ? (
            <FaChevronUp className="h-3 w-3 sm:h-4 sm:w-4" />
          ) : (
            <FaChevronDown className="h-3 w-3 sm:h-4 sm:w-4" />
          )}
        </div>
      </div>
    </div>
  );
};

export default SessionHeader;
